import {ControlledDatepicker, ControlledDatepickerValue} from '@hm/fundamental'
import {Control, Controller} from 'react-hook-form'

import {FiltersFormValues} from '../../types'
import {normalizeDatepickerRange} from '../../utils'

type SlaCommentsDatePickerProps = {
  control: Control<FiltersFormValues>
  label: string
}

export const SlaCommentsDatePicker = ({control, label}: SlaCommentsDatePickerProps) => {
  const handleChange = (
    newValue: ControlledDatepickerValue,
    onChange: (value: [Date | null, Date | null]) => void
  ) => {
    onChange(normalizeDatepickerRange(newValue))
  }

  return (
    <Controller
      name="dateRange"
      control={control}
      render={({field}) => (
        <ControlledDatepicker
          name="comments-date-range"
          label={label}
          value={field.value}
          onChange={(newValue) => handleChange(newValue, field.onChange)}
          showMonthYearPicker
        />
      )}
    />
  )
}
